import { render, staticRenderFns } from "./TotalFraisAll.vue?vue&type=template&id=c684e5d6"
import script from "./TotalFraisAll.vue?vue&type=script&lang=ts"
export * from "./TotalFraisAll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports